import { CloseOutlined } from "@ant-design/icons";
import { useNewsletterPopup } from "./useNewsletterPopup";
import Link from "next/link";

const newsletterSignupUrl = "https://go.gandpconstruction.com/l/1100853/2025-12-15/m2jzq";

interface NewsletterModalProps {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const NewsletterModal: React.FC<NewsletterModalProps> = ({ isOpen, openModal, closeModal }) => {
  const { handleDismiss } = useNewsletterPopup(isOpen, openModal, closeModal);

  const handleSignupClick = () => {
    handleDismiss();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6"
      onClick={handleDismiss}
    >
      <div className="absolute inset-0 bg-black/60" />
      <div
        className="relative w-full max-w-md rounded-[20px] bg-[#f8f3eb] px-6 py-8 shadow-[0_24px_80px_rgba(0,0,0,0.35)] sm:px-8"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={handleDismiss}
          className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full text-gray-500 transition-colors hover:bg-black/5 hover:text-gray-800"
          aria-label="Close newsletter modal"
        >
          <CloseOutlined />
        </button>

        <div className="flex flex-col items-center gap-6 pt-6 text-center sm:pt-8">
          <p className="max-w-[18rem] text-lg leading-8 text-gray-900 sm:max-w-[20rem] sm:text-[1.2rem]">
            Would you like to sign up for the G&P newsletter?
          </p>
          <div className="w-full">
            <Link className="block" onClick={handleSignupClick} href={newsletterSignupUrl} target="_blank" rel="noopener noreferrer">
              <button className="w-full rounded-sm py-3 px-6 text-center hover:bg-linear-to-t hover:from-[#ffffff25] hover:to-gcharcoal text-lg bg-gcharcoal text-gyellow font-semibold hover:cursor-pointer tracking-wide transition-all duration-200 ease-in-out hover:shadow-lg active:scale-95 active:shadow-inner">
                Subscribe to our Newsletter
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterModal;
